export default __webpack_public_path__ + "static/media/filter_alt_filled.f934b1a5.svg";